var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClusterIconDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #30bc94;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 16.88,
    ry: 16.88
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "p_890.7383008418648"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17,
    cy: 24.09,
    r: 3.02
  })), /*#__PURE__*/React.createElement("g", {
    id: "p_903.4196827488582"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 21.09,
    cy: 17,
    r: 3.02
  })), /*#__PURE__*/React.createElement("g", {
    id: "p_886.0965929088128"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.91,
    cy: 17,
    r: 3.02
  })), /*#__PURE__*/React.createElement("g", {
    id: "p_898.7779748158063"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17,
    cy: 9.91,
    r: 3.02
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClusterIconDisabled);
export default __webpack_public_path__ + "static/media/cluster-icon-disabled.ef3a216ea9f7031a590f6fe193a19062.svg";
export { ForwardRef as ReactComponent };